import { useNavigate } from 'react-router-dom'
import { trackEvent } from 'analytics/trackFunctions'

import { Tab } from '@headlessui/react'

import { toLocaleCurrency } from 'utils/dinero'
import { INTEREST_FREE_ADVANCE_MAX_AMOUNT } from 'constants/credit'

import { useLineSummaryStore, useVisitedAdvanceStore } from 'store'

import { CreditIllus, RateZeroIcon } from 'assets/icons'

import FirstTimeInAdvanceSection from '../FirstTimeInAdvanceSection'
import CreditHistory from './CreditHistory'

const AdvancesTab = () => {
  const { hasVisitedAdvance, updateHasVisitedAdvance } =
    useVisitedAdvanceStore()

  const { lineSummary } = useLineSummaryStore()

  return (
    <Tab.Panel className='min-h-64 md:max-h-[calc(100vh_-_28rem)] space-y-3 p-1 md:overflow-y-auto'>
      {lineSummary?.interestFreeIsDepleted ? (
        <AdvanceBanner />
      ) : (
        <InterestFreeBanner />
      )}
      <CreditHistory product='WALLET' />

      <FirstTimeInAdvanceSection
        setHasVisited={updateHasVisitedAdvance}
        isOpen={!hasVisitedAdvance}
      />
    </Tab.Panel>
  )
}

export default AdvancesTab

const InterestFreeBanner = () => {
  const navigate = useNavigate()

  return (
    <button
      className='w-full rounded-[10px] h-20 gap-2 grid grid-cols-personalAdvisor items-center px-4 cursor-pointer bg-blue-100 text-purple-900'
      onClick={() => {
        trackEvent({ eventName: 'bille_banner_tasa_0' })
        navigate('/pedir-adelanto/sin-interes')
      }}
      type='button'
    >
      <div className='flex flex-col items-start justify-center'>
        <h5 className='text-xs font-bold leading-5'>
          Pedí tu adelanto a Tasa 0%
        </h5>
        <p className='text-2xs font-normal leading-4'>
          Hasta{' '}
          <span className='font-bold'>
            ${toLocaleCurrency(INTEREST_FREE_ADVANCE_MAX_AMOUNT)}
          </span>{' '}
          sin interés en 1 cuota.
        </p>
      </div>
      <div className='flex items-center justify-end'>
        <RateZeroIcon />
      </div>
    </button>
  )
}

const AdvanceBanner = () => {
  const navigate = useNavigate()

  return (
    <button
      className='w-full rounded-[10px] h-20 gap-2 grid grid-cols-personalAdvisor items-center px-4 cursor-pointer bg-blue-100 text-purple-900'
      onClick={() => navigate('/pedir-adelanto')}
      type='button'
    >
      <div className='flex flex-col text-left items-start justify-center'>
        <h5 className='text-xs font-bold leading-5'>Dinero al instante</h5>
        <p className='text-2xs font-medium leading-4'>
          Comprá lo que necesites con tu tarjeta
        </p>
      </div>
      <div className='flex items-center justify-end'>
        <CreditIllus className='w-20 h-20' />
      </div>
    </button>
  )
}
